import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgModalService} from 'exc-controls-v2';

@Component({
  selector: 'app-modal-history',
  templateUrl: './modal-history.component.html',
  styles: []
})
export class ModalHistoryComponent extends ExcTranslation implements OnInit {

  @Input() data: any;

  constructor(private modal: ExgModalService) {
    super();
  }

  keyupEvent = (event: any) => {
    if (event.keyCode === 27) {
      this.close();
    }
  }

  ngOnInit(): void {
    window.addEventListener('keyup', this.keyupEvent);
  }

  close(): void {
    window.removeEventListener('keyup', this.keyupEvent);
    this.modal.close();
  }

}
